


































import { Vue, Component, Prop } from 'vue-property-decorator';
import { toStyleVal } from '@/utils';

@Component
export default class AxCard extends Vue {
  @Prop({ type: String })
  width!: string;

  @Prop({ type: String })
  height!: string;

  @Prop({ type: String, default: 'white' })
  color!: string;

  @Prop({ type: String, default: 'transparent' })
  background!: string;

  @Prop({ type: Boolean, default: false })
  flex!: boolean;

  get styleVal() {
    return toStyleVal([['color', this.color]]);
  }
}
